/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import CategoryDto from '../model/CategoryDto';
import CategoryInputDto from '../model/CategoryInputDto';
import ErrorDto from '../model/ErrorDto';
import ErrorResponse from '../model/ErrorResponse';
import PaginatedCategoriesDto from '../model/PaginatedCategoriesDto';

/**
* Category service.
* @module api/CategoryApi
* @version v0
*/
export default class CategoryApi {

    /**
    * Constructs a new CategoryApi. 
    * @alias module:api/CategoryApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createCategory operation.
     * @callback module:api/CategoryApi~createCategoryCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CategoryDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new category
     * @param {module:model/CategoryInputDto} categoryInputDto 
     * @param {module:api/CategoryApi~createCategoryCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CategoryDto}
     */
    createCategory(categoryInputDto, callback) {
      let postBody = categoryInputDto;
      // verify the required parameter 'categoryInputDto' is set
      if (categoryInputDto === undefined || categoryInputDto === null) {
        throw new Error("Missing the required parameter 'categoryInputDto' when calling createCategory");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = CategoryDto;
      return this.apiClient.callApi(
        '/api/private/category', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteCategoryById operation.
     * @callback module:api/CategoryApi~deleteCategoryByIdCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a category by ID
     * @param {Number} id ID of the category to delete
     * @param {module:api/CategoryApi~deleteCategoryByIdCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteCategoryById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteCategoryById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/private/category/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCategories operation.
     * @callback module:api/CategoryApi~getCategoriesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedCategoriesDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all categories
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page number
     * @param {Number} opts.limit Number of items per page
     * @param {module:api/CategoryApi~getCategoriesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedCategoriesDto}
     */
    getCategories(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'limit': opts['limit']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = PaginatedCategoriesDto;
      return this.apiClient.callApi(
        '/api/private/category', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getCategoryById operation.
     * @callback module:api/CategoryApi~getCategoryByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CategoryDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a category by ID
     * @param {Number} id ID of the category to update
     * @param {module:api/CategoryApi~getCategoryByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CategoryDto}
     */
    getCategoryById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getCategoryById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = CategoryDto;
      return this.apiClient.callApi(
        '/api/private/category/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCategoryById operation.
     * @callback module:api/CategoryApi~updateCategoryByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CategoryDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an existing category
     * Update an existing category by ID
     * @param {Number} id ID of the category to update
     * @param {module:model/CategoryDto} categoryDto 
     * @param {module:api/CategoryApi~updateCategoryByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CategoryDto}
     */
    updateCategoryById(id, categoryDto, callback) {
      let postBody = categoryDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCategoryById");
      }
      // verify the required parameter 'categoryDto' is set
      if (categoryDto === undefined || categoryDto === null) {
        throw new Error("Missing the required parameter 'categoryDto' when calling updateCategoryById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = CategoryDto;
      return this.apiClient.callApi(
        '/api/private/category/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
